import type { Endpoint, Request, RequestArgs, Route } from '../types.no-deps'
import type { DateString } from '../../../shared/lib/typeHelpers.no-deps'
import type { Procedure } from '../../../shared/domain/campaigns/types.no-deps'

export const route: Route = { method: 'POST', pattern: '/api/procedures/sync' }

type Params = never

type Body = {
    teams: number[]
    lastSyncTime: DateString
}

type Query = { includeDeleted?: boolean }

type Output = {
    syncTime: Date
    teams: number[]
    procedures: Array<Procedure & { isAssigned: boolean } & { isDeleted: boolean }>
}

export type SyncEndpoint = Endpoint<Params, Body, Query, Output>

export const syncRequest = (request: Request, args: RequestArgs<SyncEndpoint>) => request<SyncEndpoint>(route, args)
